module.exports = "mutation AcceptSharedContact($id: ID!) {\n  acceptContactShare(id: $id) {\n    accepted\n  }\n}\n"